<template>

	<div class="content">
		<div class="container-fluid">
			<div class="row">
                <nav class="navbar navbar-inverse girder">
							<button type="button" class="navbar-btn navbar-toggle nav navbar-nav collapsed navbar-left" data-toggle="collapse" data-target="#navbar-collapse-3"  @click="isNavOpen = !isNavOpen">
								<span class="sr-only">Toggle navigation</span>
								<span class="icon-bar"></span>
								<span class="icon-bar"></span>
								<span class="icon-bar"></span>
							</button>
						
							<button class="btn btn-danger navbar-btn navbar-right btn-lang" v-bind:class="'btn-lang-'+$store.state.setLanguage" @click="$root.$emit('PopLanguageShow')">{{$t("setLang")}}</button>					
                    <!-- Collect the nav links, forms, and other content for toggling -->
                        <ul class="nav navbar-nav collapse navbar-collapse" id="navbar-collapse-3" v-bind:class="{ 'in' : isNavOpen}">
                            <li class="menuButton" @click="isNavOpen = false"><router-link :to="'/'"><a>{{$t("menu.about")}}</a></router-link></li>
                            <li class="menuButton" @click="isNavOpen = false"><router-link :to="'/files'"><a>{{$t('menu.download')}}</a></router-link></li>
                            <li class="menuButton" @click="isNavOpen = false"><router-link :to="'/content'"><a>{{$t("menu.content")}}</a></router-link></li>
                            <li class="menuButton" @click="isNavOpen = false"><router-link :to="'/authors'"><a>{{$t("menu.authors")}}</a></router-link></li>
                            <li class="menuButton" @click="NewTabUrlOpen($store.state.discordURL)"><a>{{$t("menu.contacts")}}</a></li>
                        </ul>


                </nav>
			</div>
        </div>
	</div>
</template>

<script>
export default {
    name: 'Menu',
    data: () => ({
        isNavOpen: false,
		lang: 'ru'
    }),
    methods: {
		GetLangClass() {
			if(localStorage.W4MLanguage){
				return localStorage.W4MLanguage;
			}
			else return "en";
		},
        NewTabUrlOpen(val){
            window.open(val, '_blank')
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    a, a:visited {
        color: #ffffff !important;
        font-weight: normal;
        text-decoration: none;
    }
    a:hover, a:active {
        color: #ffea36 !important;
        text-decoration: none;
    }  
	.btn-lang {
		background-image: url('./../img/en.svg');
		background-repeat: no-repeat;
		background-size: 25px;
		background-position: 10px center;
		padding-left: 40px;
	}
	.btn-lang-ru {
		background-image: url('./../img/ru.svg');
	}
	.collapse.in {
		display: block;
		width: 100%;
	}   
    .linkArena, .linkArena:visited {
        color: #ffde9c !important;
        cursor: pointer;
    }
    linkArena:hover, linkArena:active {
        color: #ffde9c !important;
        cursor: pointer;
    }

    .menuButton {
        background: none; 
        background-color: transparent;
        background-size: auto 50px;
        width: 123px;
        text-align: center;
        transition: background 0.3s ease;
    }
    .menuButton:hover {
        background: none; 
        background-size: auto 50px;
        transition: background 0.3s ease;
    }
    @media screen and (max-width: 767px) {
        .menuButton, .menuButton:visited {
            background: none; 
            background-color: transparent;
            background-size: auto 50px;
            width: 100%;
            text-align: center;
            margin-right: -15px;
            transition: background 0.3s ease;
            border-top: 1px solid #444444;
        }
        .menuButton:hover, .menuButton:active {
            background: none; 
            background-color: #555555;
            background-size: auto 50px;
            transition: background 0.3s ease;
        }    
    }
	.navbar-btn {
		float: right;
		margin-right: 25px;
	}
	.navbar-toggle {
		float: left;
		margin-left: 25px;
	}
    .girder {
        background-color: #333333;
        background: url(../img/girder.svg) repeat-x;
        background-size: auto 50px;
        background-position: top;
        padding-left: 15px;
        padding-right: 15px;
        margin-left:50px;
        margin-right:50px;
    }
    @media screen and (max-width: 1140px) {
        .girder {
            margin-left:0px;
            margin-right:0px;
            padding: 0;
        }
    }
    .menuList {
        background-color: #333333;
    }












.navbar-brand { position: relative; z-index: 2; }

.navbar-nav.navbar-right .btn { position: relative; z-index: 2; padding: 4px 20px; margin: 10px auto; transition: transform 0.3s; }

.navbar .navbar-collapse { position: relative; overflow: hidden !important; }
.navbar .navbar-collapse .navbar-right > li:last-child { padding-left: 22px; }

.navbar .nav-collapse { position: absolute; z-index: 1; top: 0; left: 0; right: 0; bottom: 0; margin: 0; padding-right: 120px; padding-left: 80px; width: 100%; }
.navbar.navbar-default .nav-collapse { background-color: #f8f8f8; }
.navbar.navbar-inverse { background-color: #222; }
.navbar .nav-collapse .navbar-form { border-width: 0; box-shadow: none; }
.nav-collapse>li { float: right; }

.btn.btn-circle { border-radius: 50px; }
.btn.btn-outline { background-color: transparent; }

.navbar-nav.navbar-right .btn:not(.collapsed) {
    background-color: rgb(111, 84, 153);
    border-color: rgb(111, 84, 153);
    color: rgb(255, 255, 255);
}

.navbar.navbar-default .nav-collapse,
.navbar.navbar-inverse .nav-collapse {
    height: auto !important;
    transition: transform 0.3s;
    transform: translate(0px,-50px);
}
.navbar.navbar-default .nav-collapse.in,
.navbar.navbar-inverse .nav-collapse.in {
    transform: translate(0px,0px);
}


@media screen and (max-width: 767px) {
    .navbar .navbar-collapse .navbar-right > li:last-child { padding-left: 15px; padding-right: 15px; } 
    
    .navbar .nav-collapse { margin: 7.5px auto; padding: 0; }
    .navbar .nav-collapse .navbar-form { margin: 0; }
    .nav-collapse>li { float: none; }
    
    .navbar.navbar-default .nav-collapse,
    .navbar.navbar-inverse .nav-collapse {
        transform: translate(-100%,0px);
    }
    .navbar.navbar-default .nav-collapse.in,
    .navbar.navbar-inverse .nav-collapse.in {
        transform: translate(0px,0px);
    }
    
    .navbar.navbar-default .nav-collapse.slide-down,
    .navbar.navbar-inverse .nav-collapse.slide-down {
        transform: translate(0px,-100%);
    }
    .navbar.navbar-default .nav-collapse.in.slide-down,
    .navbar.navbar-inverse .nav-collapse.in.slide-down {
        transform: translate(0px,0px);
    }
}









</style>



// WEBPACK FOOTER //
// src/components/Menu.vue